/* shogazi-hub-follow.js - nur Hub /products/klappmatratze
   1) Groessenauswahl wie vor dem Wegfall von Swatch King (Schnellwahl-Karten, Vergleichslink, gruppierte Liste) auf der
      normalen Variantenauswahl; Fallback: nur der Link
   2) Kachelpaar im Inhaltsbereich folgt Groesse + Farbe (Daten: window.GZV_MEDIA, Tags #typ=..;farbe=..;groesse=..).
      Links bis 100 cm Farbfoto, ab 110 cm Hauptbild (typ=foto;pos=1;bucket=gross) der Farbe, rechts Massgrafik.
   2b) Dreier-Block "Woraus sie besteht" (.sga[data-sga], nur DE-Hub): Karte 1 (Bezug) = linkes Bild wie oben, Karte 2 = Kaltschaum (fest),
      Karte 3 (Drei Segmente) = Massgrafik + Faltmass nach Laenge (180 -> 60, 190 -> 63, 200 -> 66 cm, wie auf den Einzelseiten). */
(function () {
  'use strict';
  var COLORS = [['anthrazit', 'anthrazit'], ['anthrac', 'anthrazit'], ['antracit', 'anthrazit'], ['marine', 'marineblau'], ['navy', 'marineblau'], ['blau', 'marineblau'], ['bleu', 'marineblau'], ['blu', 'marineblau'], ['wein', 'weinrot'], ['bordeaux', 'weinrot'], ['wine', 'weinrot'], ['vino', 'weinrot'], ['rot', 'weinrot']];
  var COLOR_LABEL = { anthrazit: 'Anthrazit', weinrot: 'Weinrot', marineblau: 'Marineblau' };
  /* Farbfoto je Farbe fuer Breiten bis 100 cm: Dateinummer wie auf den Einzelseiten (klappmatratze-bequem-schlafen-statt-sofa-90-x-200-cm-<farbe>-<nummer>) */
  var PHOTO_NO = { anthrazit: '8841823', weinrot: '9526603', marineblau: '6284926' };

  function normSize(t) { var m = (t || '').match(/(\d+)\s*[x×]\s*(\d+)/i); return m ? m[1] + 'x' + m[2] : ''; }
  function colorKey(t) {
    t = (t || '').toLowerCase();
    var i = t.indexOf('/'); if (i >= 0) t = t.slice(i + 1);
    for (var k = 0; k < COLORS.length; k++) if (t.indexOf(COLORS[k][0]) >= 0) return COLORS[k][1];
    return '';
  }
  function tags(a) {
    var o = {}, i = (a || '').indexOf('#');
    if (i < 0) return o;
    a.slice(i + 1).split(';').forEach(function (kv) { var j = kv.indexOf('='); if (j > 0) o[kv.slice(0, j).trim()] = kv.slice(j + 1).trim(); });
    return o;
  }
  function fileOf(u) { return (u || '').split('?')[0].split('/').pop(); }

  /* ---------- 1) Groessenvergleich-Link ---------- */
  var LINK = '<button type="button" class="km-cmp-link" id="km-cmp-open" aria-haspopup="dialog">' + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 5h18v6H3z"/><path d="M3 11v8M21 11v8M3 19h18"/><path d="M7 5v3M11 5v2M15 5v3M19 5v2"/></svg>' + '<span></span></button>';
  function bindOverlay(btn) {
    var ov = document.getElementById('km-cmp-overlay'), cl = document.getElementById('km-cmp-close'), im = document.getElementById('km-cmp-img');
    function closeOv() { ov.classList.remove('is-open'); document.body.style.overflow = ''; btn.focus(); }
    btn.addEventListener('click', function () {
      if (im && !im.getAttribute('src')) im.src = im.getAttribute('data-src');
      ov.classList.add('is-open'); document.body.style.overflow = 'hidden'; if (cl) cl.focus();
    });
    if (cl) cl.addEventListener('click', closeOv);
    ov.addEventListener('click', function (e) { if (e.target === ov) closeOv(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && ov.classList.contains('is-open')) closeOv(); });
  }
  function initCompare() {
    var app = document.getElementById('km-size-app'), ov = document.getElementById('km-cmp-overlay');
    if (!app || !ov || document.getElementById('km-cmp-open')) return;
    if (document.querySelector('.swatch-view')) return; /* altes Auswahlfeld aktiv: dessen Code erzeugt den Link */
    app.innerHTML = '<p class="km-heading">' + LINK + '</p>';
    app.querySelector('span').textContent = app.getAttribute('data-cmp-label') || 'Alle 20 Größen vergleichen (70–160 cm)';
    bindOverlay(document.getElementById('km-cmp-open'));
  }

  /* ---------- 1b) Groessenauswahl (Schnellwahl, Link, gruppierte Liste) ---------- */
  var LOC = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
  var IS_CH = !!(window.Shopify && window.Shopify.country === 'CH');
  var KEYS = ['70x190', '70x200', '80x190', '80x200', '90x190', '90x200', '100x190', '100x200', '110x190', '110x200', '120x180', '120x190', '120x200', '130x190', '130x200', '140x190', '140x200', '150x190', '150x200', '160x200'];
  var GROUP_AT = [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2];
  var PRESET_KEYS = ['90x200', '120x200', '140x200'];
  var TXT = {
    de: { groups: ['Einzel- & Gästebett', 'Komfort & breite Größen', 'Doppelbett'], presets: ['Bestseller', 'Komfortbreite', 'Für Doppelbett'], more: 'Weitere Größen',
      tags: ['Gäste · Kinder', 'Gäste · Kinder', 'Einzelbett, schmal', 'Einzelbett, schmal', 'Einzelbett', 'Einzelbett · Bestseller', 'Einzelbett, komfort', 'Einzelbett, komfort', 'Einzelbett, extrabreit', 'Einzelbett, extrabreit', 'Komfortbreite', 'Komfortbreite', 'Komfortbreite', 'großes Einzelbett', 'großes Einzelbett', 'Doppelbett', 'Doppelbett · Standard', 'Doppelbett, breit', 'Doppelbett, breit', 'Doppelbett, groß'] },
    en: { groups: ['Single & Guest', 'Comfort Sizes', 'Double Bed'], presets: ['Bestseller', 'Comfort width', 'For double bed'], more: 'Other sizes',
      tags: ['Guest · Children', 'Guest · Children', 'Single, compact', 'Single, compact', 'Single bed', 'Single · Bestseller', 'Single, comfort', 'Single, comfort', 'Single, extra wide', 'Single, extra wide', 'Comfort width', 'Comfort width', 'Comfort width', 'Large single bed', 'Large single bed', 'Double bed', 'Double bed · Standard', 'Double bed, wide', 'Double bed, wide', 'King size double'] },
    fr: { groups: ["Lit simple & d'appoint", 'Dimensions confort', 'Lit double'], presets: ['Bestseller', 'Largeur confort', 'Pour lit double'], more: 'Autres dimensions',
      tags: ['Invités · Enfants', 'Invités · Enfants', 'Lit simple, étroit', 'Lit simple, étroit', 'Lit simple', 'Lit simple · Bestseller', 'Lit simple, confort', 'Lit simple, confort', 'Lit simple, extra-large', 'Lit simple, extra-large', 'Largeur confort', 'Largeur confort', 'Largeur confort', 'Grand lit simple', 'Grand lit simple', 'Lit double', 'Lit double · Standard', 'Lit double, large', 'Lit double, large', 'Grand lit double'] },
    it: { groups: ['Singolo & ospiti', 'Misure comfort', 'Matrimoniale'], presets: ['Bestseller', 'Larghezza comfort', 'Per matrimoniale'], more: 'Altre misure',
      tags: ['Ospiti · Bambini', 'Ospiti · Bambini', 'Singolo, stretto', 'Singolo, stretto', 'Singolo', 'Singolo · Bestseller', 'Singolo, comfort', 'Singolo, comfort', 'Singolo, extralarge', 'Singolo, extralarge', 'Larghezza comfort', 'Larghezza comfort', 'Larghezza comfort', 'Ampio singolo', 'Ampio singolo', 'Matrimoniale', 'Matrimoniale · Standard', 'Matrimoniale, largo', 'Matrimoniale, largo', 'Matrimoniale maxi'] }
  };
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  function nativeSel() { return document.querySelector('select.options-selection__input-select'); }
  function initSize() {
    var app = document.getElementById('km-size-app'), ov = document.getElementById('km-cmp-overlay'), sel0 = nativeSel();
    if (!app || !ov || !sel0 || document.getElementById('km-cmp-open')) return false;
    if (document.querySelector('.swatch-view')) return false;
    var opts = {}, count = 0, i;
    for (i = 0; i < sel0.options.length; i++) { var kk = normSize(sel0.options[i].value) || normSize(sel0.options[i].textContent); if (kk) { opts[kk] = sel0.options[i].value; count++; } }
    if (!count) return false;
    var T = TXT[LOC] || TXT.de, TAG = {};
    function tx(s) { return (IS_CH && LOC === 'de') ? s.replace(/ß/g, 'ss') : s; }
    function lab(k) { var o = nativeSel(), n = o ? o.options : sel0.options, j; for (j = 0; j < n.length; j++) if ((normSize(n[j].value) || normSize(n[j].textContent)) === k) return n[j].textContent.replace(/\s+/g, ' ').trim(); return k; }
    KEYS.forEach(function (k, j) { TAG[k] = tx(T.tags[j]); });
    var label = app.getAttribute('data-cmp-label') || 'Alle 20 Größen vergleichen (70–160 cm)';

    var presets = el('div', 'km-presets'), pEls = [];
    PRESET_KEYS.forEach(function (k, j) {
      if (!opts[k]) return;
      var d = el('div', 'km-preset'); d.setAttribute('data-key', k); d.setAttribute('role', 'button'); d.tabIndex = 0;
      d.appendChild(el('span', 'km-size', lab(k))); d.appendChild(el('span', 'km-tag', tx(T.presets[j])));
      presets.appendChild(d); pEls.push(d);
    });
    var head = el('p', 'km-heading');
    head.innerHTML = LINK;
    head.querySelector('span').textContent = label;
    var dd = el('div', 'km-dd'), trigger = el('button', 'km-dd-trigger'), tl = el('span', 'km-dd-label'), list = el('div', 'km-dd-list'), oEls = [];
    trigger.type = 'button'; trigger.setAttribute('aria-haspopup', 'listbox'); trigger.setAttribute('aria-expanded', 'false'); trigger.appendChild(tl);
    list.setAttribute('role', 'listbox');
    function optEl(k, tag) {
      var d = el('div', 'km-dd-opt'); d.setAttribute('data-key', k); d.setAttribute('role', 'option'); d.tabIndex = 0;
      d.appendChild(el('span', 'km-dd-size', lab(k))); d.appendChild(el('span', 'km-dd-tag', tag || ''));
      oEls.push(d); return d;
    }
    var lastG = -1, covered = {};
    KEYS.forEach(function (k, j) {
      if (!opts[k]) return;
      covered[k] = 1;
      if (GROUP_AT[j] !== lastG) { list.appendChild(el('div', 'km-dd-group', tx(T.groups[GROUP_AT[j]]))); lastG = GROUP_AT[j]; }
      list.appendChild(optEl(k, TAG[k]));
    });
    var extra = Object.keys(opts).filter(function (k) { return !covered[k]; });
    if (extra.length) { list.appendChild(el('div', 'km-dd-group', tx(T.more))); extra.forEach(function (k) { list.appendChild(optEl(k, '')); }); }
    dd.appendChild(trigger); dd.appendChild(list);
    while (app.firstChild) app.removeChild(app.firstChild);
    if (pEls.length) app.appendChild(presets);
    app.appendChild(head); app.appendChild(dd);

    var st = document.createElement('style');
    st.textContent = 'body.sgh-size-ui .options-selection__select-wrapper{display:none}.km-preset:focus-visible,.km-dd-opt:focus-visible,.km-dd-trigger:focus-visible{outline:2px solid #6f9a24;outline-offset:2px}';
    document.head.appendChild(st);
    document.body.classList.add('sgh-size-ui');

    var cur = '';
    function setOpen(o) { list.classList.toggle('open', o); trigger.setAttribute('aria-expanded', o ? 'true' : 'false'); }
    function reflect(k) {
      cur = k;
      var short = TAG[k] ? TAG[k].split('·')[0].trim() : '';
      tl.textContent = lab(k) + (short ? ' · ' + short : '');
      pEls.forEach(function (e) { e.classList.toggle('is-active', e.getAttribute('data-key') === k); });
      oEls.forEach(function (e) { var on = e.getAttribute('data-key') === k; e.classList.toggle('sel', on); e.setAttribute('aria-selected', on ? 'true' : 'false'); });
    }
    function choose(k) {
      var s = nativeSel(); if (!s || !opts[k]) return;
      s.value = opts[k];
      s.dispatchEvent(new Event('change', { bubbles: true }));
      reflect(k);
    }
    function follow() { var s = nativeSel(); if (!s) return; var k = normSize(s.value); if (k && k !== cur) reflect(k); }
    pEls.forEach(function (e) {
      e.addEventListener('click', function () { choose(e.getAttribute('data-key')); });
      e.addEventListener('keydown', function (ev) { if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); choose(e.getAttribute('data-key')); } });
    });
    trigger.addEventListener('click', function (e) { e.stopPropagation(); setOpen(!list.classList.contains('open')); });
    list.addEventListener('click', function (e) { var o = e.target.closest('.km-dd-opt'); if (o) { choose(o.getAttribute('data-key')); setOpen(false); } });
    list.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { var o = e.target.closest('.km-dd-opt'); if (o) { e.preventDefault(); choose(o.getAttribute('data-key')); setOpen(false); trigger.focus(); } } });
    document.addEventListener('click', function (e) { if (!app.contains(e.target)) setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
    document.addEventListener('change', function () { setTimeout(follow, 60); }, true);
    document.addEventListener('variant:change', function () { setTimeout(follow, 60); });
    setInterval(follow, 500);
    bindOverlay(head.querySelector('#km-cmp-open'));
    reflect(normSize(sel0.value) || KEYS[5]);
    return true;
  }

  /* ---------- 2) Kachelpaar folgt der Auswahl ---------- */
  function initTiles() {
    var media = window.GZV_MEDIA;
    if (!media || !media.length) return false;
    var MASS = {}, MASSFILES = {}, PHOTO = {}, HERO = {};
    media.forEach(function (m) {
      var t = tags(m.alt), f = fileOf(m.src || m.u800);
      if (t.typ === 'mass' && t.farbe && t.groesse) { MASS[t.farbe + '|' + t.groesse] = m; MASSFILES[f] = 1; }
      if (t.typ === 'foto' && t.farbe && PHOTO_NO[t.farbe] && f.indexOf('-' + PHOTO_NO[t.farbe] + '.') > 0) PHOTO[t.farbe] = m;
      if (t.typ === 'foto' && t.pos === '1' && t.bucket === 'gross' && t.farbe) HERO[t.farbe] = m;
    });
    /* nur Kachel-Gruppen anfassen, deren Bilder ausnahmslos Masgrafiken des Produkts sind */
    var duos = [].slice.call(document.querySelectorAll('.sg-img-duo')).filter(function (d) {
      var imgs = d.querySelectorAll('.sg-img-square img');
      if (!imgs.length) return false;
      for (var i = 0; i < imgs.length; i++) if (!MASSFILES[fileOf(imgs[i].getAttribute('src'))]) return false;
      return true;
    });
    var aufbau = document.querySelector('.sga[data-sga]');
    if (!duos.length && !aufbau) return true;
    if (duos.length) {
      var st = document.createElement('style');
      st.textContent = '@media(min-width:480px){.sg-img-duo.sgh-single{grid-template-columns:calc(50% - 5px);justify-content:center}}.sg-img-duo.sgh-off{display:none}';
      document.head.appendChild(st);
    }
    var last = '';
    function sel() {
      var s = document.querySelector('select[name="id"]');
      if (!s || s.selectedIndex < 0) return null;
      var t = s.options[s.selectedIndex].textContent || '';
      var size = normSize(t), color = colorKey(t);
      return size && color ? color + '|' + size : null;
    }
    function setImg(tile, m, alt, key) {
      var img = tile.querySelector('img');
      img.removeAttribute('srcset');
      img.src = m.u800 || m.src;
      img.alt = alt;
      img.width = 800; img.height = 800;
      img.setAttribute('data-sgh-key', key);
      tile.hidden = false;
    }
    var FOLD = { '180': '60', '190': '63', '200': '66' };
    function setCard(li, m, alt, key) {
      var imgs = li.querySelectorAll('img'), box = li.querySelector('input.sga-zt');
      if (!m) { li.classList.add('sga-nomedia'); if (box) box.checked = false; return; }
      li.classList.remove('sga-nomedia');
      var u = m.u800 || m.src;
      if (imgs[0]) { imgs[0].removeAttribute('srcset'); imgs[0].src = u; imgs[0].alt = alt; imgs[0].width = 800; imgs[0].height = 800; imgs[0].setAttribute('data-sgh-key', key); }
      if (imgs[1]) { imgs[1].removeAttribute('srcset'); imgs[1].src = u.replace('width=800', 'width=1400'); imgs[1].alt = ''; }
    }
    function applyAufbau(color, size, ph, m, key) {
      var c1 = aufbau.querySelector('[data-sga-card="bezug"]'), c3 = aufbau.querySelector('[data-sga-card="segmente"]');
      if (c1) setCard(c1, ph, 'shogazi® Klappmatratze ' + COLOR_LABEL[color], key);
      if (c3) {
        setCard(c3, m, m ? (m.alt || '').split('#')[0].trim() : '', key);
        var p = c3.querySelector('[data-sga-seg]'), sp = size.split('x'), f = FOLD[sp[1]];
        if (p) p.textContent = 'Drei Kerne sitzen passgenau im gemeinsamen Bezug. Zweifach klappbar' + (f ? ', zusammengelegt ' + sp[0] + ' × ' + f + ' × 36 cm.' : '.');
      }
    }
    function apply(key) {
      var kp = key.split('|'), color = kp[0], width = parseInt(kp[1], 10), m = MASS[key], list = [];
      var ph = width >= 110 ? HERO[color] : PHOTO[color];
      if (ph) list.push([ph, 'shogazi® Klappmatratze ' + COLOR_LABEL[color]]);
      if (m) list.push([m, (m.alt || '').split('#')[0].trim()]);
      duos.forEach(function (d) {
        var tiles = d.querySelectorAll('.sg-img-square'), n = 0;
        for (var i = 0; i < tiles.length; i++) {
          if (list[i]) { setImg(tiles[i], list[i][0], list[i][1], key); n++; } else tiles[i].hidden = true;
        }
        d.classList.toggle('sgh-off', n === 0);
        d.classList.toggle('sgh-single', n === 1);
      });
      if (aufbau) applyAufbau(color, kp[1], ph, m, key);
    }
    function update() {
      var k = sel();
      if (!k || k === last) return;
      last = k; apply(k);
    }
    var tmr = null;
    function schedule() { clearTimeout(tmr); tmr = setTimeout(update, 60); }
    document.addEventListener('change', schedule, true);
    document.addEventListener('variant:change', schedule);
    document.addEventListener('click', schedule, true);
    setInterval(update, 500);
    update();
    return true;
  }

  function boot() {
    if (!initSize()) initCompare();
    if (!initTiles()) { var n = 0, t = setInterval(function () { if (initTiles() || ++n > 40) clearInterval(t); }, 150); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();